import type { DraggableAttributes } from '@dnd-kit/core';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { GripVertical } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface TreeDndHandleProps {
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  disabled?: boolean;
  className?: string;
}

export function TreeDndHandle({
  listeners,
  attributes,
  disabled,
  className,
}: TreeDndHandleProps) {
  const { LL } = useI18nContext();

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn(
        'size-7 shrink-0 cursor-grab touch-manipulation text-muted-foreground disabled:cursor-not-allowed disabled:opacity-40',
        className
      )}
      disabled={disabled}
      aria-label={LL.audiences.filters.dragToReorder()}
      {...attributes}
      {...listeners}
    >
      <GripVertical className="size-4" />
    </Button>
  );
}
